import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  RegisterData,
  emailRules,
  passwordRules,
  firstnameRules,
  lastnameRules,
} from '@/models/login.model';
import { Actions, ShiftCMSState } from '@/store';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterForm',
  setup(__props) {

const store = useStore<ShiftCMSState>();
const router = useRouter();

const valid = ref<boolean>(true);
const registerData = ref<RegisterData>({
  email: '',
  password: '',
  firstName: '',
  lastName: '',
});

const register = async () => {
  if (valid.value) {
    const success = await store.dispatch(Actions.Register, registerData.value);

    if (success) {
      router.push('/login');
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    width: "50%",
    class: "mx-auto register-form",
    elevation: "4"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, {
        modelValue: valid.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((valid).value = $event)),
        onSubmit: _withModifiers(register, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Register", -1)),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    md: "6",
                    class: "mx-auto"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: registerData.value.firstName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((registerData.value.firstName) = $event)),
                        rules: _unref(firstnameRules),
                        label: "First name",
                        required: ""
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    class: "mx-auto"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: registerData.value.lastName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((registerData.value.lastName) = $event)),
                        rules: _unref(lastnameRules),
                        label: "Last name",
                        required: ""
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    md: "6",
                    class: "mx-auto"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: registerData.value.email,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((registerData.value.email) = $event)),
                        rules: _unref(emailRules),
                        label: "E-mail",
                        required: ""
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    md: "6",
                    class: "mx-auto"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: registerData.value.password,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((registerData.value.password) = $event)),
                        rules: _unref(passwordRules),
                        label: "Password",
                        type: "password",
                        required: ""
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { col: "2" }),
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        class: "mt-2",
                        type: "submit",
                        block: ""
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("Submit")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { col: "2" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})